import React, {Fragment} from 'react';

import {AlertModal} from 'presentation/components';
import {translations} from 'presentation/translations-new';

import {ModalError} from 'presentation/components/ModalError';
import {PendingDialog} from 'presentation/pages/private/booking/components';
import {UploadModalsProps} from './types';

const {modalSendingAttach} = translations['pt-br'].privateFlow.refund.uploadRefundFiles;
const {notice, agreementText, deleting} = translations['pt-br'].commons;
const {
	errorTitle,
	description: errorModalDescription,
	tryAgainBtn,
	subtitle,
} = translations['pt-br'].others.genericErrorModal;

export const UploadModals = ({
	openErrorModal,
	closeErrorModa,
	closeSendingAttachModal,
	openSendingAttachModal,
	openPendingDialog,
	closePendingDialog,
}: UploadModalsProps) => (
	<Fragment>
		<PendingDialog open={openPendingDialog} onClose={closePendingDialog} text={deleting} />

		<AlertModal
			onClose={closeSendingAttachModal}
			open={openSendingAttachModal}
			headerTitle={notice}
			title={modalSendingAttach.title}
			description={modalSendingAttach.description}
			variant="info"
			buttonLabel={agreementText}
			customIconName="timelapse-filled"
		/>

		<ModalError
			open={openErrorModal}
			onClose={closeErrorModa}
			headerTitle={errorTitle}
			title={subtitle}
			description={errorModalDescription}
			maxWidth={420}
			firstButton={{
				title: tryAgainBtn,
				handleClick: closeErrorModa,
			}}
		/>
	</Fragment>
);
